import { store } from 'store.js';
import axios from 'axios';
import { API_URL } from 'config.js';
import { caricamento, aggiornaRequests, aggiornaQueryResults, errore, resetErrore } from 'features/requests/requestsSlice';

const API_REQUESTS_URL = `${API_URL}/generals/get_altre_ricerche/`;
const API_REQUESTS_QUERY_URL = `${API_URL}/generals/get_altre_ricerche_query/`;

export async function richiediDati() {
  store.dispatch(caricamento(true));
  store.dispatch(resetErrore());

  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  try {
    const res = await axios.post(API_REQUESTS_URL, { utente, pin });

    const {
      data: { successo, dati = [], errore: messaggioErrore },
    } = res;

    if (successo) {
      store.dispatch(aggiornaRequests(dati ?? []));
      store.dispatch(resetErrore());
    } else {
      // Mostra sempre un errore quando successo è false
      const erroreMsg = messaggioErrore || 'Errore nel caricamento delle requests. La richiesta non è stata completata con successo.';
      store.dispatch(errore(erroreMsg));
      store.dispatch(aggiornaRequests([]));
    }
  } catch (error) {
    console.error('Error loading requests:', error);
    const erroreMsg = error.response?.data?.errore || error.message || 'Errore di connessione durante il caricamento delle requests';
    store.dispatch(errore(erroreMsg));
    store.dispatch(aggiornaRequests([]));
  }

  store.dispatch(caricamento(false));
}

export async function richiediQueryDati(requestId) {
  if (!requestId) {
    store.dispatch(aggiornaQueryResults([]));
    store.dispatch(resetErrore());
    return;
  }

  store.dispatch(caricamento(true));
  store.dispatch(resetErrore());

  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  try {
    const res = await axios.post(API_REQUESTS_QUERY_URL, { utente, pin, id: requestId });

    const {
      data: { successo, dati = [], errore: messaggioErrore },
    } = res;

    if (successo) {
      store.dispatch(aggiornaQueryResults(dati ?? []));
      store.dispatch(resetErrore());
    } else {
      // Mostra sempre un errore quando successo è false
      const erroreMsg = messaggioErrore || 'Errore nel caricamento dei risultati della query. La richiesta non è stata completata con successo.';
      store.dispatch(errore(erroreMsg));
      store.dispatch(aggiornaQueryResults([]));
    }
  } catch (error) {
    console.error('Error loading query results:', error);
    const erroreMsg = error.response?.data?.errore || error.message || 'Errore di connessione durante il caricamento dei risultati';
    store.dispatch(errore(erroreMsg));
    store.dispatch(aggiornaQueryResults([]));
  }

  store.dispatch(caricamento(false));
}
